export const getRequestOptions: any = {
  method: "GET",
  credentials: "include",
};
export const postRequestOptionsFetch: any = {
  method: "POST",
  credentials: "include",
};
//api.triadacapital.com
// export let baseUrl = "http://localhost:8080/api/web/";
// export let eblotUrl = "http://localhost:8081/api/web/";
// export let eblotApp = "http://localhost:3001/";

export let baseUrl = "https://api.triadacapital.com/api/web/";
export let eblotUrl = "https://eblotapi.triadacapital.com/api/web/";
export let eblotApp = "https://eblot.triadacapital.com/";

export const postRequestOptions: any = {
  method: "POST",
  withCredentials: "include",
};
export const getAxiosRequestOptions: any = {
  method: "GET",
  withCredentials: "include",
};

export const handleAuth = (status: number) => {
  if (status == 200) {
  } else if (status == 401) {
    window.location.href = "/login";
  }
};

export default {};
